import { formatCurrency } from '~libs/dataUtils';
import { Column, Row } from '~components/table-view-v3';

import PaymentBatchRowAction from '~direct-debits/components/payment-batches/PaymentBatchRowAction';
import PaymentStatusBadge from '~direct-debits/components/payment-batches/PaymentStatusBadge';
import { formatBatchDate } from '~direct-debits/lib/formatBatchDate';
import { PaymentBatch } from '~direct-debits/models';

const formatBatchIdShort = (id: string): string => {
  if (!id) return '—';
  // Show only the first 8 chars of the UUID-like batch identifier — full
  // value remains accessible via row data and the level 2 detail view.
  return id.length > 8 ? `${id.slice(0, 8)}…` : id;
};

export interface BatchListCallbacks {
  onSelectBatch?: (batchId: string) => void;
}

export const columnsFactory = (callbacks: BatchListCallbacks = {}): Column[] => [
  {
    id: 'id',
    header: 'Batch ID',
    type: 'text',
    deriveValue: (row) => formatBatchIdShort(row.id as string),
  },
  {
    id: 'collection_date',
    header: 'Collection Date',
    type: 'text',
    deriveValue: (row) => formatBatchDate(row.collection_date as string | null),
    classNames: { header: 'cell-align-center', column: 'cell-align-center' },
  },
  {
    id: 'status',
    header: 'Status',
    type: 'custom',
    component: PaymentStatusBadge,
    classNames: { header: 'cell-align-center', column: 'cell-align-center' },
  },
  {
    id: 'client_count',
    header: 'Clients',
    type: 'text',
    deriveValue: (row) => String(row.client_count ?? 0),
    classNames: { header: 'cell-align-center', column: 'cell-align-center' },
  },
  {
    id: 'total_amount',
    header: 'Total Amount',
    type: 'text',
    deriveValue: (row) => formatCurrency(row.total_amount as string),
    classNames: { header: 'cell-align-right', column: 'cell-align-right' },
  },
  {
    id: 'created_at',
    header: 'Created',
    type: 'text',
    deriveValue: (row) => formatBatchDate(row.created_at as string),
    classNames: { header: 'cell-align-center', column: 'cell-align-center' },
  },
  {
    id: 'actions',
    header: '',
    type: 'custom',
    component: PaymentBatchRowAction,
    componentProps: callbacks,
    classNames: { header: 'cell-align-right', column: 'cell-align-right' },
  },
];

export type PaymentBatchRow = Row & PaymentBatch;
